<template>
    <div>
        <barraprincipaladmin @abrir="mtMenuVisible"> </barraprincipaladmin>
        <menulateral @cerrar="mtMenuVisible" :value="menu_visible"> </menulateral>

        <v-container fluid>   

            <div class="claro elevation-5">
                <v-row dense>     
                    <v-col cols="12" md="12" class="d-flex align-center px-4">
                        <h2 class="primary--text">Servicios requeridos</h2>                    
                    </v-col>                    
                </v-row>
            </div>      

            <br>           

            <v-row class="d-flex justify-end" dense>

                <v-col cols="12" sm="12" md="1" class="d-flex justify-end">                    
                    <v-btn dense color="primary" class="mx-0" @click="crearServicio()" block dark> <v-icon>mdi-plus</v-icon> Crear</v-btn>
                </v-col>

                <v-col cols="12" sm="12" md="3">
                    <v-select :items="listado_estatus" v-model="estatus_seleccionado" label='Estatus' outlined dense></v-select>
                </v-col>

                <v-col cols="12" sm="12" md="2">
                    <v-menu v-model="modalFec1" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field v-model="fecha_busqueda1" label="Fecha inicial" append-icon="mdi-calendar" readonly dense outlined v-bind="attrs" v-on="on"></v-text-field>
                        </template>
                        <v-date-picker v-model="fecha_busqueda1" @input="modalFec1 = false"></v-date-picker>
                    </v-menu>
                </v-col>
                
                <v-col cols="12" sm="12" md="2">
                    <v-menu v-model="modalFec2" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field v-model="fecha_busqueda2" label="Fecha final" append-icon="mdi-calendar" readonly dense outlined v-bind="attrs" v-on="on"></v-text-field>
                        </template>
                        <v-date-picker v-model="fecha_busqueda2" @input="modalFec2 = false"></v-date-picker>
                    </v-menu>
                </v-col>                

                <v-col cols="12" sm="12" md="2">
                    <v-btn @click="getInformacionFiltros(estatus_seleccionado, fecha_busqueda1, fecha_busqueda2)" dense color="secondary" block> <v-icon>mdi-magnify</v-icon> Consultar</v-btn>
                </v-col>

                <v-col cols="12" sm="12" md="1">
                    <v-btn @click="descargarServicios()" dense color="success" block> <v-icon>mdi-cloud-download-outline</v-icon></v-btn>
                </v-col>
                
            </v-row>           

            <v-row>
                <v-col cols="12" sm="12">
                    <div class="mx-0">
                        <v-data-table                              
                            dense                             
                            :headers="tabla_encabezado" 
                            :items="servicios"
                            :item-class="color_fondo"                        
                            :items-per-page="-1"
                            class="elevation-1"
                            mobile-breakpoint="100"                       
                            multi-sort
                            :search="busqueda"   
                            loading-text="Consultando información..."
                            :loading="cargando"
                            no-data-text="No se encontró información."
                            locale="es-MX"
                            :footer-props="{
                                'items-per-page-text':'Elementos por página',
                                'items-per-page-all-text': 'Todos',
                                'show-current-page':true,
                                'show-first-last-page': true,                                                                                 
                                'page-text':page_text
                            }"
                            @pagination="texto_paginacion"                                         
                        >   
    
                        <!-- Acciones -->                                                
                        <template v-slot:item.acciones="{ item }">
                            <div class="d-flex justify-end">                                             
                                <v-btn v-if="item.idestatus == 1" title="Eliminar" icon color="error" @click="eliminarServicio(item.id)"><v-icon>mdi-delete-circle-outline</v-icon></v-btn>
                                <v-btn v-if="item.idestatus == 1" title="Editar" icon color="warning" @click="editar(item.id)"><v-icon>mdi-pencil</v-icon></v-btn>
                                <v-btn v-if="item.idestatus == 3" title="Marcar terminado" icon color="success" @click="marcarTerminado(item.id)"><v-icon>mdi-checkbox-marked-circle-outline</v-icon></v-btn>                            
                                <v-btn v-if="item.idestatus == 4" title="Archivos adjuntos" icon color="primary" @click="abrirDialogoArchivos(item.id)"><v-icon>mdi-paperclip</v-icon></v-btn>                            
                                <v-btn title="Ver más" icon color="primary" @click="verDetalleServicio(item.id)"><v-icon>mdi-information-outline</v-icon></v-btn>
                            </div>
                        </template>   
    
    
                        </v-data-table>
                    </div>
                </v-col>
            </v-row>
    
            <v-snackbar v-model="snackbar" :color="snackbarcolor" dark>
                <div class="d-flex justify-center"><strong>{{snackbartexto}}</strong></div>
            </v-snackbar>        

            <v-dialog v-if="dlgservicio" v-model="dlgservicio" max-width="900">
                <v-card>
                    <v-card-title class="d-flex justify-center primary--text">
                        {{titulo_formulario_servicio}}
                    </v-card-title>

                    <v-card-text>
                        <v-row dense>
                            <v-col cols="12" sm="3">
                                <v-text-field label="Folio" v-model="svfolio" maxlength="10" autofocus dense outlined></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="9">
                                <v-text-field label="Descripción del servicio requerido" v-model="svdescripcion" maxlength="100" dense outlined></v-text-field>
                            </v-col>
                        </v-row>

                        <v-row dense>
                            <v-col cols="12">
                                <v-text-field label="Se requiere temporalmente contar con los servicios de una persona física con conocimientos en:" v-model="svpspconocimientos" outlined dense></v-text-field>
                            </v-col>
                        </v-row>
                      

                        <v-row dense class="accent2 primary--text" v-if="actividadesrealizar.length > 0">
                            <v-col cols=""><b>Actividad</b></v-col>
                            <v-col cols=""><b>Área</b></v-col>
                            <v-col cols=""><b>Periodo</b></v-col>
                            <v-col cols=""><b>Días</b></v-col>
                            <v-col cols=""><b>Horario</b></v-col>
                            <v-col cols=""><b>Horas</b></v-col>
                            <v-col cols=""><b>Subtotal</b></v-col>
                        </v-row>


                        <v-row v-for="(item, key) of actividadesrealizar" :key="key" dense class="d-flex oscuro--text">                             
                            <v-col cols="12" sm="12">
                                <b>{{item.actividad}}</b>
                            </v-col>
                            <v-col cols="12" sm="1">
                                <v-icon v-if="modo_pantalla != 'detalle'" @click="quitarActividad(item)" color="error">mdi-trash-can-outline</v-icon>
                            </v-col>                            
                            <v-col cols="12" sm="2">
                                {{item.area.nombre}}
                            </v-col>
                            <v-col cols="12" sm="3">
                                {{item.periodo_inicio}} a {{item.periodo_fin}}
                            </v-col>
                            <v-col cols="12" sm="1">
                                {{item.dias}}
                            </v-col>
                            <v-col cols="12" sm="3">
                                {{item.horario}}
                            </v-col>
                            <v-col cols="12" sm="1">
                                {{item.horas}}
                            </v-col>
                            <v-col cols="12" sm="1">
                                {{item.monto}}
                            </v-col>
                            <v-col cols="12" sm="12">
                                <v-divider></v-divider>
                            </v-col>
                        </v-row>

                        <div v-if="modo_pantalla != 'detalle'" class="elevation-4 pa-2 accent2"> 
                            <v-row dense>
                                <v-col cols="12">
                                    <v-text-field hide-details label='Actividad que realizará' v-model='svactividades' outlined dense></v-text-field>
                                </v-col>
                            </v-row>
    
                            <v-row dense>
                                <v-col cols="11" sm="5">
                                    <v-select hide-details label='Area' v-model="svarea" :items="svitemareas" outlined dense></v-select>
                                </v-col>
                                <v-col cols='1' sm="1" class="mt-2">
                                    <v-icon color="success" @click="dlgarea = true" title="Nueva área">mdi-plus-circle-outline</v-icon>
                                </v-col>           
                            </v-row>

                            <v-row dense>
                                <v-col cols="12" sm="6">
                                    <v-dialog ref="dlrangofechas" v-model="svdlgrango" :return-value.sync="svperiodo" width="290px" persistent>                                    
                                        <template v-slot:activator="{ on, attrs}">
                                            <v-text-field hide-details v-bind="attrs" v-on="on" label="Periodo" v-model="formatoPeriodo" outlined dense readonly> </v-text-field>
                                        </template>
                                        <v-date-picker v-model="svperiodo" scrollable range no-title>
                                            <v-spacer></v-spacer>
                                            <v-btn v-if="svperiodo != null && svperiodo.length == 2" color="success" @click="$refs.dlrangofechas.save(svperiodo)">Aceptar</v-btn>
                                            <v-btn color="error" @click="svdlgrango = false">Cancelar</v-btn>
                                        </v-date-picker>
                                    </v-dialog>
                                </v-col>  
                                <v-col cols="4" sm="4">
                                    <v-text-field hide-details hide-spin-buttons label="Días" v-model="svdias" outlined dense type="number"></v-text-field>
                                </v-col>      
                            </v-row>
                        

                            <v-row dense>
                                
                                <!-- <v-col cols="6" sm="4">
                                    <v-dialog ref='dlrangohoras' v-model="svdlghoras" :return-value.sync="svhorario" persistent width="600px">
                                        <template v-slot:activator="{on ,attrs}">
                                            <v-text-field hide-details v-bind="attrs" v-on="on" label="Horario" v-model="formatoRangoHoras" outlined dense readonly></v-text-field>
                                            <v-spacer></v-spacer>
                                        </template>

                                        <div class="d-flex justify-center">
                                            <v-time-picker v-if="svdlghoras" v-model="svhorario" >   
                                                <v-spacer></v-spacer>                                
                                                <v-btn :disabled="svhorario == null && svhorariofin == null" color="success" @click="$refs.dlrangohoras.save(svhorario, svhorariofin)">Aceptar</v-btn>                                                                                                            
                                            </v-time-picker>
                                            <v-time-picker v-if="svdlghoras" v-model="svhorariofin" >        
                                                <v-spacer></v-spacer>                                                                            
                                                <v-btn class='error' @click="svdlghoras = false">Cerrar</v-btn>
                                            </v-time-picker>
                                        </div>
                                    </v-dialog>
                                </v-col> -->

                                <!-- Horarios nuevo inicio  -->                               
                                <v-col cols='12' sm="12" md="3">
                                    <v-btn @click="dlhorarios = true" color="primary" dense>Agregar horario</v-btn>
                                </v-col>
                                <!-- Horarios nuevo fin -->                                
                            </v-row>

                            <v-row dense v-if="svhorarios.length > 0">
                                <v-col cols="12" > <span><b>Horarios agregados</b></span> </v-col>
                                <v-col class="ml-3" cols="12" v-for="hrr, key in svhorarios" :key="key">
                                    <v-icon class="mr-5" color="error" @click="eliminarHorario(hrr)" title="Nueva área">mdi-trash-can-outline</v-icon>      
                                    <b>{{hrr.horario}}</b>                           
                                </v-col>                              
                            </v-row>

                            <v-row>
                                <v-col cols="4" sm="4">
                                    <v-text-field hide-details hide-spin-buttons label="Horas" v-model="svhoras" outlined dense type="number"></v-text-field>
                                </v-col>
                            </v-row>

                            <v-row >
                                <v-col cols="12" sm="3">
                                    <v-text-field hide-spin-buttons type="number" label="Monto sin IVA/Por hora" v-model="svmontohora" hide-details outlined dense></v-text-field>
                                </v-col>
                                <v-spacer></v-spacer>
                                <v-col cols="12" sm="4" class="black--text">
                                    <div>Subtotal= $ {{cpSubTotal}}</div>
                                    <div>IVA= $ {{cpIva}} </div>
                                    <div>IVA Retenido= $ {{cpIVARetenido}}</div>
                                    <div>ISR Retenido= $ {{cpISRRetenido}}</div>
                                </v-col>
                                <!-- <v-col cols="12" sm="3" class="d-flex align-center black--text">
                                    IVA Retenido= $ {{cpIVARetenido}}                             
                                </v-col>
                                <v-col cols="12" sm="3" class="d-flex align-center black--text">
                                    ISR Retenido= $ {{cpISRRetenido}}
                                </v-col> -->
                            </v-row>

                            <v-row dense>
                                <v-col cols="12" class="d-flex justify-end">
                                    <v-btn dark color="primary" @click="agregarActividad()" dense>Agregar actividad</v-btn>
                                </v-col>
                            </v-row>

                        </div>

                        <v-row class="d-flex justify-end mt-2">
                            <v-col cols="12" class="d-flex justify-end">
                                <v-btn dark v-if="modo_pantalla == 'crear'" color="success" :loading='svguardando' @click="guardarServicio">Guardar</v-btn>
                                <v-btn dark v-if="modo_pantalla == 'editar'" color="success" :loading='svguardando' @click="actualizarServicio">Guardar cambios</v-btn>
                                <v-btn dark class="ml-2" color="error" @click="dlgservicio = false">Cancelar</v-btn>
                            </v-col>
                        </v-row>

                    </v-card-text>
                </v-card>
            </v-dialog>

            <v-dialog v-model="dlgarea" v-if="dlgarea" max-width="400" persistent>
                <v-card>
                    <v-card-title class="d-flex justify-center">
                        Área 
                    </v-card-title>
                    <v-card-text>
                        <v-row dense>
                            <v-col cols="12">
                                <v-text-field v-model="dlgnombrearea" hide-details="true" autofocus dense outlined></v-text-field>
                            </v-col>
                        </v-row>

                        <v-row dense>
                            <v-col cols="12" class="d-flex justify-end">                                
                                <v-btn dark text color="green" @click="agregarArea()">Agregar</v-btn>
                                <v-btn dark text color="red" @click="dlgarea = false">Cancelar</v-btn>
                            </v-col>
                        </v-row>
                    </v-card-text>                    
                </v-card>                
            </v-dialog>

            <v-dialog v-model="dlhorarios" v-if="dlhorarios" max-width="650" persistent>
                <v-card>
                    <v-card-title class="d-flex justify-center">
                        Horario 
                    </v-card-title>
                    <v-card-text>
                        <v-row dense>
                            <v-col cols="12" sm="12" md="6">
                                <v-time-picker v-model="svhorario"> </v-time-picker>
                            </v-col>
                            <v-col cols="12" sm="12" md="6">
                                <v-time-picker v-model="svhorariofin"></v-time-picker>
                            </v-col>
                        </v-row>

                        <v-row dense>
                            <v-col cols="12" class="d-flex justify-end">                                
                                <v-btn dark text color="green" @click="agregarHorario()">Agregar</v-btn>
                                <v-btn dark text color="red" @click="dlhorarios = false">Cancelar</v-btn>
                            </v-col>
                        </v-row>
                    </v-card-text>                    
                </v-card>                
            </v-dialog>

            <v-dialog v-model="dlarchivosadjuntos" v-if="dlarchivosadjuntos" max-width="600" transition="dialog-top-transition">
                <v-card>
                    <v-card-title class="d-flex justify-center primary--text">
                        Archivos adjuntos
                    </v-card-title>
                    <br><br>
                    <v-card-text class="d-flex flex-column justify-center">
                        <v-progress-circular v-if="consultandoadjuntos" indeterminate color="primary"></v-progress-circular>

                        <div v-for="(archivo, index) in archivosadjuntos" :key="index" class="d-flex flex-column">
                            <div class="my-2">
                                <v-btn @click="descargarArchivo(idservicioeditado, archivo)" dense> 
                                    {{archivo}} 
                                    <v-icon color="primary" class="ml-3">mdi-download</v-icon>
                                </v-btn>
                            </div>
                        </div>

                        <div v-if="archivosadjuntos.length == 0 && consultandoadjuntos == false">
                            No hay archivos adjuntos
                        </div>

                    </v-card-text>
                    <br><br>
                    <!-- <v-card-text class="d-flex">
                        <v-file-input hide-details="true" v-model="archivoadjunto" label="Carta de liberación" dense outlined></v-file-input>
                        <v-btn @click="enviarArchivo(idservicioeditado, archivoadjunto)" class="ml-3" color="primary" :loading="enviandoarchivo" dense>Enviar</v-btn>
                    </v-card-text> -->
                    <v-card-actions class="d-flex justify-end" @click="dlarchivosadjuntos = false">
                        <v-btn color="error" dense>
                            Cerrar
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <dislogoconfirmacion ref="dialogoconfirmacion"></dislogoconfirmacion>


        </v-container>        
    </div>
</template>

<script>

import menulateral from "@/components/MenuLateralAdmin";
import barraprincipaladmin from "@/components/BarraPrincipalAdmin";

import dislogoconfirmacion from '@/components/DialogoConfirmacion'

const numeral = require('numeral')
const moment = require('moment')
moment.locale('es-mx')

import XLSX from 'xlsx'

export default {

    components:{
        menulateral,
        barraprincipaladmin,
        dislogoconfirmacion
    },

    data() {
        return {

            modo_pantalla: 'crear',
            menu_visible: false,
            titulo_formulario_servicio: 'Nuevo servicio requerido',

            snackbartexto: "",
            snackbar: false,            
            snackbarcolor: "",  
                        
            busqueda:'',
            tabla_encabezado:[],
            servicios: [],
            page_text:'',
            cargando:true,           
                        
            color_fondo:"blue lighten-4",

            dlgservicio: false,
            svdlgrango: false,
            svdlghoras: false,
            svfolio: '',
            svdescripcion: '',
            svpspconocimientos: '',
            svactividades: '',
            svitemareas: [],
            svarea: '',
            svperiodo: null,
            svdias: 0,
            svhorario: "09:00",
            svhorariofin: "09:00",
            dlhorarios: false,

            svhorarios: [],

            svhoras: 0,
            svmontohora: 0,            
            svguardando: false,

            dlgarea: false,
            dlgnombrearea: '',

            guardando: false,

            dlgdetalleservicio: false,
            itemserviciodetalle: [],

            actividadesrealizar: [],
            horascalculadas: 0,

            eliminando: false,
            
            //Edicion
            idservicioeditado: 0,
         
            dlarchivosadjuntos: false,
            archivoadjunto: null,
            consultandoadjuntos: false,
            archivosadjuntos: [],
            enviandoarchivo: false,
            porcentaje_subido: '',

            //Filtros
            listado_estatus:[
                {value: 1, text: "Pendiente de contrato"},
                {value: 2, text: "Contrato asignado"},
                {value: 3, text: "Contrato firmado"},
                {value: 4, text: "Servicio finalizado"},
                {value: 0, text: "Cancelado"},
                {value: -1, text: "Todos"},
            ],

            estatus_seleccionado: 1,

            fecha_busqueda1: new Date(new Date().getTime() - (24*60*60*1000) * 60).toISOString().substr(0,10),
            modalFec1: false,

            fecha_busqueda2: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
            modalFec2: false,

        }
    }, 
    
    watch:{
        svfolio(val){
            this.svfolio = val.toUpperCase()
        },
        svperiodo(val){
            if(val != null && val.length > 1){
                this.svdias = (new Date(val[1]) - new Date(val[0])) / (1000 * 60 * 60 * 24) + 1
            }
        },
        // svhorariofin(){
        //     if(this.svhorario != null && this.svhorariofin){
        //         //Se deja la fecha fija, solo es para calcular las horas
        //         this.horascalculadas =  (new Date("2022-06-22 "+this.svhorariofin) - new Date("2022-06-22 "+this.svhorario) ) / 1000 / 60 /60 

        //         // if(this.svdias > 0)
        //         //     this.svhoras = this.horascalculadas * this.svdias
                
        //         // if(this.svdias == 0)
        //         //     this.svhoras = this.horascalculadas
                
        //     }
        // },
        svdias(){
            
            if(this.svhorarios.length > 0){
                let horasasignadas = 0
                for(let hr of this.svhorarios){
                    horasasignadas += hr.horas
                }

                this.svhoras = this.svdias * horasasignadas
            }
            else{
                this.svhoras = 0
            }

            // if(this.svhoras > 0){               
            //     this.svhoras = this.svdias * this.svhoras
            // }
        }       

    },

    computed:{
        formatoPeriodo(){
            //TODO Formato correcto del periodo
            if(this.svperiodo != null)
                return 'Del '+ this.svperiodo.join(' al ')
            else
                return ''
        },
        formatoRangoHoras(){
            if(this.svhorario != null && this.svhorariofin != null){
                return 'De '+ this.svhorario + ' a ' + this.svhorariofin + ' hrs'
            }
            else{
                return ''
            }
        },
        cpSubTotal(){
            return numeral((this.svmontohora * this.svhoras)).format('0.00')
        },
        cpIva(){
            return numeral((this.svmontohora * this.svhoras) * .16).format('0.00')
        },
        cpTotal(){
            return numeral((this.svmontohora * this.svhoras) * 1.16).format('0.00')
        },
        cpIVARetenido(){
            return numeral(((this.svmontohora * this.svhoras) * .16) * (2/3)).format('0.00')
        },
        cpISRRetenido(){
            return numeral((this.svmontohora * this.svhoras) * .10).format('0.00')
        }


        // Total= $ {{(svmonto * svhoras) * 1.16}}
        // </v-col>
        // <v-col cols="12" sm="2" class="d-flex align-center black--text">
        //     IVA Retenido= $ {{ ((svmonto * svhoras) * .16) * (2/3) }}
        // </v-col>
        // <v-col cols="12" sm="4" class="d-flex align-center black--text">
        //     ISR Retenido= $ {{ ((svmonto * svhoras) * 1.16) * .10}}
        
    },

    beforeCreate() {
        const token = sessionStorage.getItem('datax')
               
        this.axios.post(this.$url+'/acceso/validatoken/usuario', {}, {headers: {Authorization: `Bearer ${token}`}})     
            .then((response)=>{

                const data = response.data
                
                if(data.codigo == 'lgout')
                    this.$router.push({"name":'AdminLogin'})
            
            })
            .catch((error)=>{
                console.log("Error "+error);
            })
    },

    created() {
        this.getInformacion(this.fecha_busqueda1, this.fecha_busqueda2)
        this.getAreas()
    },

    methods: {
        mtMenuVisible(value){
            this.menu_visible = value
        },   
        
        texto_paginacion: function(pg){           
            this.page_text = 'Total elementos '+pg.itemsLength
        },
        
        getInformacion(fechainicio, fechafin){
            const token = sessionStorage.getItem('datax')
            
            this.cargando = true
            this.servicios = []
            this.axios.get(this.$url+'/admin/serviciosrequeridos/listado/'+fechainicio+"/"+fechafin, {headers: {Authorization:`Bearer ${token}`}})
                .then((response)=>{
                    const data = response.data
                    
                    if(!data.error){
                        //Encabezados de la tabla
                        this.tabla_encabezado = []
                        for(let key in data.servicios[0]){                                
                            if(key == 'folio' || key == 'estatus')                        
                                this.tabla_encabezado.push({
                                    text:key.toUpperCase(), 
                                    value:key, 
                                    class:"oscuro--text"                        
                                })  
                            if(key == 'descripcion')                        
                                this.tabla_encabezado.push({
                                    text:'DESCRIPCIÓN', 
                                    value:key, 
                                    class:"oscuro--text"                        
                                })
                            if(key == 'alta')                           
                                this.tabla_encabezado.push({
                                    text: 'ALTA',
                                    value:key,
                                    class:"oscuro--text"
                                })
                            if(key == 'alta_usuario')                           
                                this.tabla_encabezado.push({
                                    text: 'USUARIO ALTA',
                                    value:key,
                                    class:"oscuro--text"
                                })
                            if(key == 'modificacion_usuario')                           
                                this.tabla_encabezado.push({
                                    text: 'MODIFICADO POR',
                                    value:key,
                                    class:"oscuro--text"
                                })
                        }
                            
                        //Agrego la columna de acciones a la tabla
                        this.tabla_encabezado.push({
                            text:"ACCIONES",
                            value:"acciones",
                            align:"center",
                            class:"oscuro--text"
                        })

                        this.servicios = data.servicios
                    }
                    else{
                        this.snackbartexto = data.mensaje
                        this.snackbarcolor = 'red'
                        this.snackbar = true
                        if(data.codigo == 'lgout')
                            this.$router.push({name:'AdminLogin'})
                    }


                })
                .catch((error)=>{
                    console.log("Ocurrio un error "+error);
                })
                .finally(()=>{
                    this.cargando = false
                })
        }, 

        getInformacionFiltros(estatus, fechainicio, fechafin){
            const token = sessionStorage.getItem('datax')
            
            this.cargando = true
            this.servicios = []
            this.axios.get(this.$url+'/admin/serviciosrequeridos/listado/'+estatus+'/'+fechainicio+'/'+fechafin, {headers: {Authorization:`Bearer ${token}`}})
                .then((response)=>{
                    const data = response.data
                    
                    if(!data.error){
                        //Encabezados de la tabla
                        this.tabla_encabezado = []
                        for(let key in data.servicios[0]){                                
                            if(key == 'folio' || key == 'estatus')                        
                                this.tabla_encabezado.push({
                                    text:key.toUpperCase(), 
                                    value:key, 
                                    class:"oscuro--text"                        
                                })  
                            if(key == 'descripcion')                        
                                this.tabla_encabezado.push({
                                    text:'DESCRIPCIÓN', 
                                    value:key, 
                                    class:"oscuro--text"                        
                                })
                            if(key == 'alta')                           
                                this.tabla_encabezado.push({
                                    text: 'ALTA',
                                    value:key,
                                    class:"oscuro--text"
                                })
                            if(key == 'alta_usuario')                           
                                this.tabla_encabezado.push({
                                    text: 'USUARIO ALTA',
                                    value:key,
                                    class:"oscuro--text"
                                })
                            if(key == 'modificacion_usuario')                           
                                this.tabla_encabezado.push({
                                    text: 'MODIFICADO POR',
                                    value:key,
                                    class:"oscuro--text"
                                })
                        }
                            
                        //Agrego la columna de acciones a la tabla
                        this.tabla_encabezado.push({
                            text:"ACCIONES",
                            value:"acciones",
                            align:"center",
                            class:"oscuro--text"
                        })

                        this.servicios = data.servicios
                    }
                    else{
                        this.snackbartexto = data.mensaje
                        this.snackbarcolor = 'red'
                        this.snackbar = true
                        if(data.codigo == 'lgout')
                            this.$router.push({name:'AdminLogin'})
                    }


                })
                .catch((error)=>{
                    console.log("Ocurrio un error "+error);
                })
                .finally(()=>{
                    this.cargando = false
                })
        }, 
        
        getAreas(){

            this.axios.get(this.$url+'/catalogos/servicios/areas/listado')
                .then((response)=>{
                    const data = response.data
                    
                    if(!data.error){
                        this.svitemareas = data.areas
                    }
                    else{
                        this.snackbartexto = data.mensaje
                        this.snackbarcolor = 'red'
                        this.snackbar = true
                    }
                })
                .catch(()=>{
                    this.snackbartexto = "Error al consultar áreas."
                    this.snackbarcolor = 'red'
                    this.snackbar = true
                })

        },

        agregarArea(){

            if(this.guardando)
                return

            if(this.dlgnombrearea.trim() == '')
                return

            const token = sessionStorage.getItem('datax')

            this.guardando = true
            this.axios.post(this.$url+'/catalogos/servicios/areas/agregar', {area:this.dlgnombrearea}, {headers:{Authorization:`Bearer ${token}`}})
                .then((response)=>{
                    
                    const data = response.data
                    if(!data.error){
                        this.svarea = data.id
                        this.getAreas()
                    }
                    else{
                        this.snackbartexto = data.mensaje
                        this.snackbarcolor = 'red'
                        this.snackbar = true
                    }

                })
                .finally(()=>{                    
                    this.dlgarea = false
                    this.dlgnombrearea = ''
                    this.guardando = false
                })
        },

        agregarHorario(){

            let rango = this.svhorario+ ' a '+this.svhorariofin
            let hrcalculadas =  (new Date("2022-06-22 "+this.svhorariofin) - new Date("2022-06-22 "+this.svhorario) ) / 1000 / 60 /60 

            this.svhorarios.push({horario:rango, horas:hrcalculadas})

            if(this.svdias > 0){
                this.svhoras += hrcalculadas * this.svdias
            }
                
            if(this.svdias == 0)
                this.svhoras += parseFloat(this.horascalculadas)

            this.dlhorarios = false
        },

        eliminarHorario(horario){
            
             if(this.svdias > 0)
                    this.svhoras -= parseFloat(horario.horas) * parseFloat(this.svdias)
                
            if(this.svdias == 0)
                this.svhoras -= parseFloat(horario.horas)



            for (let i = 0; i < this.svhorarios.length; i++) {
                const hr = this.svhorarios[i];
                if(hr == horario){
                    this.svhorarios.splice(i, 1)                
                    break;
                }
            }          
            
        },

        crearServicio(){
            this.consultarMontoPorHora()
            this.limpiaFormularioServicio()
            this.titulo_formulario_servicio = 'Nuevo servicio requerido'
            this.modo_pantalla = 'crear'
            this.dlgservicio = true
        },

        guardarServicio(){           

            if(!this.svfolio || !this.svdescripcion || !this.svpspconocimientos){
                this.snackbartexto = "Todos los campos son requeridos."
                this.snackbar = true
                this.snackbarcolor = 'error'                
                return
            }

            if(this.actividadesrealizar.length == 0){
                this.snackbartexto = "Es necesario agregar minimo una actividad."
                this.snackbar = true
                this.snackbarcolor = 'error'                
                return
            }

            if(this.svguardando){
                console.log("Ya guardando");             
                return 
            }

            this.svguardando = true

            const token = sessionStorage.getItem('datax')

            const datos = {
                folio: this.svfolio,
                descripcion: this.svdescripcion,
                actividades: this.actividadesrealizar,
                pspconocimientos: this.svpspconocimientos
                // idarea: this.svarea.id,
                // periodo_inicio: this.svperiodo[0],
                // periodo_fin: this.svperiodo[1],
                // dias: this.svdias,
                // horario: 'De '+ this.svhorario + ' a '+ this.svhorariofin,
                // horas: this.svhoras
            }

            
            this.axios.post(this.$url+'/admin/serviciosrequeridos/crear', {datos}, {headers:{Authorization:`Bearer ${token}`}})
                .then((response)=>{
                    
                    const data = response.data
                    if(!data.error){
                        this.snackbartexto = data.mensaje
                        this.snackbarcolor = 'success'
                        this.snackbar = true
                        this.dlgservicio = false
                        this.limpiaFormularioServicio()
                        //Cargar los servicios
                        this.getInformacion(this.fecha_busqueda1, this.fecha_busqueda2)
                    }
                    else{
                        this.snackbartexto = data.mensaje
                        this.snackbarcolor = 'error'
                        this.snackbar = true
                    }

                })
                .finally(()=>{                                       
                    this.svguardando = false
                })

        },

        limpiaFormularioServicio(){
            this.svfolio = '',
            this.svdescripcion = null,
            this.svactividades = null,
            this.svpspconocimientos = '',
            this.actividadesrealizar = []

            this.svactividades = '',
            this.svarea = '',
            this.svperiodo = null,
            this.svdias = 0,
            this.svhorario = "09:00",
            this.svhorariofin = "09:00",
            this.svhorarios = [],
            this.svhoras = 0,
            this.svmontohora = 0       
        },

        // verDetalleServicio(item){
        //     this.itemserviciodetalle = item
        //     this.dlgdetalleservicio = true
        // },

        agregarActividad(){

            // if(!this.svactividades || this.svarea.length == 0 || !this.svperiodo || this.svdias == 0 || !this.svhorario || !this.svhorariofin || this.svhoras == 0 || this.svmonto == 0){
            if(!this.svactividades || this.svarea.length == 0 || !this.svperiodo || this.svdias == 0 || this.svhoras == 0 || this.svmonto == 0){
                this.snackbartexto = "Todos los campos de la actividad son requeridos"
                this.snackbar = true
                this.snackbarcolor = 'red'
                return
            }

            if(this.svhorarios.length == 0  ){
                this.snackbartexto = "Se requiere agregar minimo un horario"
                this.snackbar = true
                this.snackbarcolor = 'red'
                return
            }

            
            let sthorarios = ""

            for(let hr of this.svhorarios){
                sthorarios += hr.horario + ', '
            }


            const actividad = {
                actividad: this.svactividades,
                area: this.svarea,
                periodo_inicio: this.svperiodo[0],
                periodo_fin: this.svperiodo[1],
                dias: this.svdias,
                horario: 'De '+ sthorarios,
                horas: this.svhoras,
                monto: this.cpSubTotal
            }
            
            this.actividadesrealizar.push(actividad)

            // this.svarea = []                        
            // this.svhorario = ''
            // this.svhorariofin = ''         

            this.svactividades = '',
            this.svarea = '',
            this.svperiodo = null,
            this.svdias = 0,
            // this.svhorario = null,
            // this.svhorariofin = null,
            this.svhorarios = [],
            this.svhoras = 0,
            this.svmontohora = 0 
        },

        quitarActividad(item){

            for (let i = 0; i < this.actividadesrealizar.length; i++) {
                const element = this.actividadesrealizar[i];
                if(element == item){
                    this.actividadesrealizar.splice(i, 1)                
                    break;
                }
            }
         
        },
        
        async eliminarServicio(id){

            const confirma = await this.$refs.dialogoconfirmacion.abrir({
                titulo: '¿Realmente quiere eliminar el servicio?',
                confirmar: 'Si',
                cancelar: 'No'
            })

            if(!confirma){
                return
            }
           

            const token = sessionStorage.getItem('datax')

            this.eliminando = true
            this.axios.delete(this.$url+'/admin/serviciosrequeridos/eliminar/'+id, {headers:{Authorization:`Bearer ${token}`}})
                .then((response)=>{
                    console.log(response);
                    const data = response.data

                    if(!data.error){
                        this.snackbartexto = data.mensaje
                        this.snackbarcolor = 'success'
                        this.snackbar = true

                        this.getInformacion(this.fecha_busqueda1, this.fecha_busqueda2)
                    }
                    else{
                        this.snackbartexto = data.mensaje
                        this.snackbarcolor = 'error'
                        this.snackbar = true
                    }


                })
                .catch((error)=>{
                    console.log("Ocurrio un error");
                    console.log(error);
                })
                .finally(()=>{
                    this.eliminando = true
                })
        },

        consultarMontoPorHora(){
            const token = sessionStorage.getItem("datax")

            this.axios.get(this.$url+'/admin/parametros_especiales/valor/contratos/monto_por_hora', {headers:{"authorization":`Bearer ${token}`}})
                .then((response)=>{
                    const data = response.data

                    if(!data.error && data.valor != null){
                        this.svmontohora = parseFloat(data.valor)
                    }

                })

        },

        async marcarTerminado(idservicio){        

            const confirma = await this.$refs.dialogoconfirmacion.abrir({
                titulo: '¿Realmente quiere terminar el servicio?',
                confirmar: 'Si',
                cancelar: 'No'
            })


            if(!confirma){
                return
            }
           
            const datos = {
                cservicio: idservicio,
                libera_nombre: 'JESÚS DANIEL HERNANDÉZ CAMACHO',
                libera_puesto: 'SUBDIRECTOR ACADÉMICO'
            }

            const token = sessionStorage.getItem('datax')
            
            this.axios.put(this.$url+'/admin/serviciosrequeridos/marcarterminado', {datos:datos}, {headers:{Authorization:`Bearer ${token}`}})
                .then((response)=>{
                    console.log(response);
                    const data = response.data

                    if(!data.error){
                        this.snackbartexto = data.mensaje
                        this.snackbar = true
                        
                        if(!data.alerta)
                            this.snackbarcolor = 'success'
                        else    
                            this.snackbarcolor = 'warning'                        
                        
                        this.generaPDFLiberacion(idservicio)
                        this.getInformacion(this.fecha_busqueda1, this.fecha_busqueda2)
                    }
                    else{
                        this.snackbartexto = data.mensaje
                        this.snackbarcolor = 'error'
                        this.snackbar = true
                    }


                })
                .catch((error)=>{
                    console.log("Ocurrio un error");
                    console.log(error);
                })
                .finally(()=>{
                    
                })           
            
        },

        generaPDFLiberacion(idservicio) {
            
            const token = sessionStorage.getItem('datax')

            this.axios.get(this.$url+'/admin/serviciosrequeridos/pdfliberacion/'+idservicio, {headers:{Authorization:`Bearer ${token}`}, responseType: 'blob'})
                .then((response)=>{                    
                    const tipo_contenido = response.headers['content-type']
                    const file = new Blob([response.data], {type:tipo_contenido});                            
                    const fileURL = URL.createObjectURL(file)
                    window.open(fileURL)
                })
                .catch((error)=>{
                    console.log("Ocurrio un error");
                    console.log(error);
                })
                .finally(()=>{
                    
                })
        },        

        editar(id){
            this.limpiaFormularioServicio()            
            this.titulo_formulario_servicio = 'Editar servicio'
            this.modo_pantalla = 'editar'
            this.idservicioeditado = id

            const token = sessionStorage.getItem('datax')
            
            this.cargando = true
            this.axios.get(this.$url+'/admin/serviciosrequeridos/detalle/'+id, {headers: {Authorization:`Bearer ${token}`}})
                .then((response)=>{
                    const data = response.data
                    const sd = data.serviciodetalle
                    
                    if(!data.error){
                        this.dlgservicio = true
                        this.svfolio = sd.folio
                        this.svdescripcion = sd.descripcion
                        this.svpspconocimientos = sd.pspconocimientos


                        this.actividadesrealizar = []

                       
                        for(let act of sd.actividades){

                            const actividad = {
                                actividad: act.actividad,                                
                                area: {"id":act.idarea, "nombre":act.area},
                                periodo_inicio: act.periodo_inicio,
                                periodo_fin: act.periodo_fin,
                                dias: act.dias,
                                horario: act.horario,
                                horas: act.horas,
                                monto: numeral(act.subtotal).format('0.00')
                            }
                            
                             this.actividadesrealizar.push(actividad)
                        }

                    }
                    else{
                        this.snackbartexto = data.mensaje
                        this.snackbarcolor = 'red'
                        this.snackbar = true
                        if(data.codigo == 'lgout')
                            this.$router.push({name:'AdminLogin'})
                    }


                })
                .catch((error)=>{
                    console.log("Ocurrio un error "+error);
                })
                .finally(()=>{
                    this.cargando = false
                })
        },

        verDetalleServicio(id){
            this.limpiaFormularioServicio()            
            this.titulo_formulario_servicio = 'Detalle del servicio'
            this.modo_pantalla = 'detalle'
            this.idservicioeditado = id

            const token = sessionStorage.getItem('datax')
            
            this.cargando = true
            this.axios.get(this.$url+'/admin/serviciosrequeridos/detalle/'+id, {headers: {Authorization:`Bearer ${token}`}})
                .then((response)=>{
                    const data = response.data
                    const sd = data.serviciodetalle
                    
                    if(!data.error){
                        this.dlgservicio = true
                        this.svfolio = sd.folio
                        this.svdescripcion = sd.descripcion
                        this.svpspconocimientos = sd.pspconocimientos


                        this.actividadesrealizar = []

                       
                        for(let act of sd.actividades){

                            const actividad = {
                                actividad: act.actividad,                                
                                area: {"id":act.idarea, "nombre":act.area},
                                periodo_inicio: act.periodo_inicio,
                                periodo_fin: act.periodo_fin,
                                dias: act.dias,
                                horario: act.horario,
                                horas: act.horas,
                                monto: numeral(act.subtotal).format('0.00')
                            }
                            
                             this.actividadesrealizar.push(actividad)
                        }

                    }
                    else{
                        this.snackbartexto = data.mensaje
                        this.snackbarcolor = 'red'
                        this.snackbar = true
                        if(data.codigo == 'lgout')
                            this.$router.push({name:'AdminLogin'})
                    }


                })
                .catch((error)=>{
                    console.log("Ocurrio un error "+error);
                })
                .finally(()=>{
                    this.cargando = false
                })
        },

        actualizarServicio(){
            
            if(!this.svfolio || !this.svdescripcion || !this.svpspconocimientos){
                this.snackbartexto = "Todos los campos son requeridos."
                this.snackbar = true
                this.snackbarcolor = 'red'                
                return
            }

            if(this.actividadesrealizar.length == 0){
                this.snackbartexto = "Es necesario agregar minimo una actividad."
                this.snackbar = true
                this.snackbarcolor = 'red'                
                return
            }

            if(this.svguardando){
                console.log("Ya guardando");             
                return 
            }

            this.svguardando = true

            const token = sessionStorage.getItem('datax')

            const datos = {
                folio: this.svfolio,
                descripcion: this.svdescripcion,
                actividades: this.actividadesrealizar,
                pspconocimientos: this.svpspconocimientos              
            }
            
            this.axios.put(this.$url+'/admin/serviciosrequeridos/actualizar/'+this.idservicioeditado, datos, {headers:{Authorization:`Bearer ${token}`}})
                .then((response)=>{
                    
                    const data = response.data
                    if(!data.error){
                        this.snackbartexto = data.mensaje
                        this.snackbarcolor = 'success'
                        this.snackbar = true
                        this.dlgservicio = false
                        this.limpiaFormularioServicio()
                        //Cargar los servicios
                        this.getInformacion(this.fecha_busqueda1, this.fecha_busqueda2)
                    }
                    else{
                        this.snackbartexto = data.mensaje
                        this.snackbarcolor = 'error'
                        this.snackbar = true
                    }

                })
                .finally(()=>{                                       
                    this.svguardando = false
                })

        },

        abrirDialogoArchivos(cservicio){
            this.obtenerArchivosAdjuntos(cservicio)
            this.idservicioeditado = cservicio
            this.dlarchivosadjuntos = true
        },  

        obtenerArchivosAdjuntos(cservicio){
            const token = sessionStorage.getItem('datax')

            this.consultandoadjuntos = true
            this.axios.get(this.$url+'/admin/serviciosrequeridos/archivosadjuntos/'+cservicio, {headers:{"authorization":`Bearer ${token}`}})
                .then((response)=>{
                    const data = response.data

                    if(!data.error){
                        this.archivosadjuntos = data.adjuntos
                    }
                    else{
                        this.snackbarcolor = "error"
                        this.snackbartexto = data.mensaje
                        this.snackbar = true

                    }


                })
                .finally(()=>{
                    this.consultandoadjuntos = false
                })

        },  

        enviarArchivo(cservicio, archivo){    
            
            if(!archivo)
                return

            if (archivo.type != 'application/pdf' && archivo.type != 'image/jpeg' && archivo.type != 'image/png') {               
                this.snackbartexto = "Tipo de archivo no valido..."
                this.snackbarcolor = 'error'
                this.snackbar = true
                return                   
            }
           

            if( (archivo.size / 1024) > 5120 ){
                this.snackbartexto = "Archivo supera el tamaño maximo 5mb"
                this.snackbarcolor = "error"
                this.snackbar = true
                return
            }

            const token = sessionStorage.getItem('datax')

            let data = new FormData();
            data.set('enctype', 'multipart/form-data')
            data.append("cservicio", cservicio)
            data.append("file", archivo)
            data.append('_method', 'PUT')

            this.enviandoarchivo = true
            this.axios.put(this.$url+'/admin/serviciosrequeridos/adjuntararchivo', data,                         
                        {
                            headers: {Authorization: `Bearer ${token}`},
                            onUploadProgress: progressEvent =>{                            
                                this.porcentaje_subido ='Subiendo archivos... '+ Math.round(progressEvent.loaded / progressEvent.total * 100) + "%"                                
                            }
                        }                        
                    )
                .then((response)=>{

                    if(response.data){
                        if(response.data.error){
                            this.snackbar = true;
                            this.snackbarcolor = "error";
                            this.snackbartexto = response.data.mensaje
                        }
                        else{
                            this.snackbar = true;
                            this.snackbarcolor = "success";
                            this.snackbartexto = response.data.mensaje
                            this.archivoadjunto = null
                            this.obtenerArchivosAdjuntos(cservicio)
                        }
                    }
                    else{
                        this.snackbar = true;
                        this.snackbar_color = "error";
                        this.snackbar_texto = "Error al subir documentos, intente mas tarde." 
                    }
                })
                .catch(()=>{
                    this.snackbar = true;
                    this.snackbar_color = "error";
                    this.snackbar_texto = "Error al subir documentos, intente mas tarde."                    
                })
                .finally(()=>{
                    this.enviandoarchivo = false
                })
        },

        descargarArchivo(cservicio, archivo){            
            const token = sessionStorage.getItem('datax')
            const data = {
                cservicio: cservicio,
                archivo: archivo
            }

            //Funciona bien en Firefox
            this.axios.post(this.$url+"/admin/serviciosrequeridos/archivosadjuntos/descargar", {data:data}, 
                    {
                        headers: {Authorization: `Bearer ${token}`},
                        responseType: 'blob'
                    })
          
                .then((response)=>{  

                    if(response.data.error)
                        return

                    const tipo_contenido = response.headers['content-type']
                    const file = new Blob([response.data], {type:tipo_contenido});                            
                    const fileURL = URL.createObjectURL(file)
                    window.open(fileURL)

                })
                .catch((error)=>{
                    console.log("Descarga archivo "+error);
                })
        },

        descargarServicios(){    
            
            const salida = new Array()
            
            this.servicios.forEach(srv => {  
                salida.push({"Folio":srv.folio, "Descripción":srv.descripcion, "Estatus":srv.estatus, "Alta":srv.alta, "Usuario alta":srv.alta_usuario, "Modificado por":srv.modificacion_usuario})                                         
            });
          
            let data = XLSX.utils.json_to_sheet(salida);
            const workbook = XLSX.utils.book_new();
            const filename = "Servicios";
            XLSX.utils.book_append_sheet(workbook, data, filename);
            
            XLSX.writeFile(workbook, `${filename}.xlsx`);

        }

    },
}
</script>
 
<style>
  
   
</style>